import { render, staticRenderFns } from "./ProducerTopProductComponent.vue?vue&type=template&id=0373ec2c&scoped=true"
import script from "./ProducerTopProductComponent.vue?vue&type=script&lang=js"
export * from "./ProducerTopProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373ec2c",
  null
  
)

export default component.exports